'use strict';

var StrategyTemplatesPanelDirective = function StrategyTemplatesPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/strategy-templates-panel.html'),
    controller: 'StrategyTemplatesPanelController',
    scope: {
      strategyTemplates: '=',
      closePanelHandler: '&',
      expandCollapseHandler: '&',
      collapsed: '='
    }
  };
};
StrategyTemplatesPanelDirective.$inject = [];
module.exports = StrategyTemplatesPanelDirective;